import '@PROJECT_ROOT/assets/desktop/js/jquery/plugins/jquery.pjax.min'; // jQuery PJAX plugin
import '@PROJECT_ROOT/assets/desktop/js/jquery/ui/jquery.ui.effect.min'; // jQuery UI effect core
import '@PROJECT_ROOT/assets/desktop/js/jquery/ui/jquery.ui.effect-slide.min'; // slide effect za pjax tranziciju
import '@PROJECT_ROOT/assets/desktop/js/library/initPjax';
